export default __webpack_public_path__ + "static/media/bot-action-4-Kellen.4e8b96af.mp4";